<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-7">
        <article class="panel">
          <p class="panel-heading">
            Orikan Configuration
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" placeholder="Required" maxlength="100">
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Base URL">
              <div class="control">
                <input formControlName="BaseUrl" class="input" placeholder="Required" maxlength="200">
                <app-validator [For]="Form.get('BaseUrl')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Username">
              <div class="control">
                <input formControlName="Username" class="input" placeholder="Username" maxlength="100">
                <app-validator [For]="Form.get('Username')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Password">
              <div class="control">
                <input formControlName="Password" type="password" class="input" [placeholder]="!this.ModelIsNew ? 'Password hidden for security - leave blank to keep existing password' : 'Password'" maxlength="100">
                <app-validator [For]="Form.get('Password')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="input" placeholder="Optional description" maxlength="500"></textarea>
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}